/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MaterialReactTable from "material-react-table";

import { useMemo } from "react";

function InvoiceSprayList({ title, rows, totalCost, shadow }) {
  const columns = useMemo(
    () => [
      {
        header: "Orchard",
        accessorKey: "orchard",
      },
      {
        accessorKey: "hectares",
        header: "Ha",
      },
      {
        accessorKey: "date",
        header: "Spray Date",
      },
      {
        accessorKey: "chemicalName",
        header: "Chemical",
      },
      {
        accessorKey: "totalused",
        header: "Total Used",
      },
      {
        accessorKey: "cost",
        header: "Cost",
      },
      {
        accessorKey: "chemicalcost",
        header: "Chem. Cost",
        aggregationFn: "sum",
        AggregatedCell: ({ cell, table }) => (
          <>
            Total Cost - {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
            <MDBox sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}>
              {cell.getValue()?.toLocaleString?.("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </MDBox>
          </>
        ),
        Cell: ({ cell }) =>
          cell.getValue()?.toLocaleString?.("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
        Footer: () => (
          <Stack>
            Invoice Total:
            <MDBox color="warning.main">
              {totalCost.toLocaleString?.("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </MDBox>
          </Stack>
        ),
      },
    ],
    [totalCost]
  );

  return (
    <Card sx={{ height: "100%", boxShadow: !shadow && "none" }}>
      <MDBox pt={4} px={2}>
        <MDTypography variant="h4" fontWeight="medium" textTransform="capitalize">
          {title}
        </MDTypography>
      </MDBox>
      <MDBox pt={4} px={2}>
        <MaterialReactTable
          columns={columns}
          data={rows}
          enableGrouping
          enableStickyHeader
          enableStickyFooter
          enableSelectAll={false}
          enableColumnActions={false}
          enablePagination={false}
          initialState={{
            density: "compact",
            expanded: false,
            grouping: ["orchard", "date"],
            pagination: { pageIndex: 0, pageSize: 20 },
            sorting: [{ id: "orchard", desc: false }],
            tableLayout: "fixed",
          }}
          muiToolbarAlertBannerChipProps={{ color: "primary" }}
          muiTableContainerProps={{ sx: { maxHeight: 700 } }}
          muiTableHeadCellProps={{
            sx: () => ({
              backgroundColor: "lightblue",
            }),
          }}
          muiTableBodyRowProps={({ row }) => ({
            onClick: row.getToggleSelectedHandler(),
            hover: false,
            sx: () => ({
              backgroundColor: row.original.color,
              cursor: "pointer",
            }),
          })}
        />
      </MDBox>
    </Card>
  );
}

// Setting default props for the ProfilesList
InvoiceSprayList.defaultProps = {
  shadow: true,
};

// Typechecking props for the ProfilesList
InvoiceSprayList.propTypes = {
  title: PropTypes.string.isRequired,
  shadow: PropTypes.bool,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalCost: PropTypes.number.isRequired,
};

export default InvoiceSprayList;
